import { SERVER_API } from "../../Constant";
import axios from "axios";

// Bank Accounts
export const FetchBankAccounts_api = async () => {
  try {
    const response = await axios.get(`${SERVER_API}/Bank/fetch_accounts.php`);
    return response.data;
  } catch (error) {
    console.error("Fetch bank accounts failed:", error);
    return { error: "Fetch bank accounts failed" };
  }
};

export const AddBankAccount_api = async (payload: any) => {
  try {
    const formData = new FormData();
    formData.append("inputs", JSON.stringify(payload));
    const response = await axios.post(
      `${SERVER_API}/Bank/add_account.php`,
      formData,
    );
    return response.data;
  } catch (error) {
    console.error("Add bank account failed:", error);
    return { error: "Add bank account failed" };
  }
};

export const UpdateBankAccount_api = async (payload: any) => {
  try {
    const formData = new FormData();
    formData.append("inputs", JSON.stringify(payload));
    const response = await axios.post(
      `${SERVER_API}/Bank/update_account.php`,
      formData,
    );
    return response.data;
  } catch (error) {
    console.error("Update bank account failed:", error);
    return { error: "Update bank account failed" };
  }
};

// Transactions
export const FetchBankTransactions_api = async (
  page = 1,
  limit = 10,
  filters: any = {},
) => {
  try {
    const response = await axios.get(
      `${SERVER_API}/Bank/fetch_transactions.php`,
      {
        params: { page, limit, ...filters },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Fetch transactions failed:", error);
    return { error: "Fetch transactions failed" };
  }
};

export const AddBankTransaction_api = async (payload: any) => {
  try {
    const formData = new FormData();
    formData.append("inputs", JSON.stringify(payload));
    const response = await axios.post(
      `${SERVER_API}/Bank/add_transaction.php`,
      formData,
    );
    return response.data;
  } catch (error) {
    console.error("Add transaction failed:", error);
    return { error: "Add transaction failed" };
  }
};
